'use client'
import { type FC } from 'react'
import type { TypeCmsVideoExternal } from '@/schema'
import { VideoGeneric } from '@/components/base/VideoGeneric'

type Props = {
  data: {
    col?: { from: number, expand: number },
    row?: { from: number, expand: number },
    id: number,
    media: {
      video: TypeCmsVideoExternal
    }
  }
}

export const ContentVideoNew:FC<Props> = ({ data }) => {
  const { media } = data

  return (
    <VideoGeneric data={media.video} />
  )
}
